// extracted by mini-css-extract-plugin
export var icon = "_51-3";
export var subtitle = "_51-2";
export var title = "_51-1";
export var value = "_51-0";